import { lazyLoad } from 'utils/lazy';

export const Services = lazyLoad(
  () => import('./Services'),
  (module) => module.Services
);
